import Card from 'react-bootstrap/Card';
import Couple from "../assets/images/couple.png"
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';

function HeaderAndFooterExample(props) {
  return (
    <div 
      style={{
        display:'flex',
        justifyContent:"center",
        backgroundColor:"#f6f7f7",
        backgroundSize:"cover",
        backgroundRepeat:"no-repeat",
        height:'100vh',
        flexDirection:"column",
        width:"100%",
        alignItems:"center",
      }}
    >
      <div style={{display:"flex", justifyContent:"center"}}>
          <img 
            src={Couple} 
            alt="couple fighting"
            style={{
              height:"20vh"
            }}
          />
      </div>
      <Card className="text-cente44r" style={{maxWidth:"340px", width:"100%", border:"0px solid white"}}>
        <Card.Body>
          <Auth 
            supabaseClient={props.supabase} 
            appearance={{ theme: ThemeSupa }} 
            providers={['google']} // 👈 Only show Google
            onlyThirdPartyProviders // 👈 Hide email/password option
          />
        </Card.Body>
      </Card>
      <div style={{position:"absolute", bottom:"0px", right:"10px", fontFamily:"lato", fontSize:"10px"}}><b>TURBO BUTTER</b></div>
    </div>
  );
}

export default HeaderAndFooterExample;